/*
 * @Author: 邓鹏
 * @Date: 2026-04-22 10:11:15
 * @LastEditors: 邓鹏
 * @LastEditTime: 2026-08-28 18:37:43
 * @FilePath: /marketing-landing-fe/src/const/uagwUserId.ts
 * @Description:
 */
export var X_UAGW_USER_ID = '';